import { render, staticRenderFns } from "./ConfirmMailForm.vue?vue&type=template&id=74341c36"
import script from "./ConfirmMailForm.vue?vue&type=script&lang=ts"
export * from "./ConfirmMailForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseContainer: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseContainer.vue').default})
